import {DataSource, RequestMetadata} from './types';
import {Row, FilterMetadata} from '../../ng-data-table';
import {DataTable} from '../../ng-data-table/base/data-table';
import {ColumnBase} from '../../ng-data-table/base/column-base';
import {ColumnModelGenerator} from '../../ng-data-table/base/column-model-generator';
import {CdtSettings} from './cdt-settings';
import {DtMessages} from '../../dt-translate';
import { SelectItem } from 'lib/common';

export class DataManager extends DataTable {

  readonly settings: CdtSettings;
  readonly DB_TZ: number;
  readonly DB_BRDiff: number;
  readonly MainFilterTZ: number;
  readonly service: DataSource;
  readonly rsltType: string;
  readonly selectedColumns: SelectItem[] = [];
  readonly rsltTypeActual: string;
  ResultOrFileType: number;
  readonly requestID: string;
  readonly respColumnsList: string[] = [];
  item: any;
  refreshRowOnSave: boolean;
  pagerCache: any = {};

  constructor(columns: ColumnBase[], settings: CdtSettings, dataSource: DataSource, DB_TZ?: number, DB_BRDiff?: number, MainFilterTZ?: number, selectedColumns?: SelectItem[], messages?: DtMessages, rsltType?: string, rsltTypeActual?: string,
    ResultOrFileType?: number, requestID?: string) {
    // super(((x) => { columns.unshift(x); return columns; })(ColumnModelGenerator.actionColumn), settings, messages);
    super(settings.unshiftExpandIcon === true ? ((x) => { columns.unshift(x); return columns; })(ColumnModelGenerator.actionColumn) : columns, settings, messages, DB_TZ, DB_BRDiff, MainFilterTZ);
    super(settings.unPopDelIcon === true ? ((x) => { columns.push(x); return columns; })(ColumnModelGenerator.delColumn) : columns, settings, messages, DB_TZ, DB_BRDiff, MainFilterTZ);
    //super(columns, settings, messages);
    this.settings = new CdtSettings(settings);
    this.DB_TZ = DB_TZ;
    this.DB_BRDiff = DB_BRDiff;
    this.MainFilterTZ = MainFilterTZ;
    this.clientSide = false;
    //this.refreshed = false;
    this.service = dataSource;
    this.rsltType = rsltType;
    this.selectedColumns = selectedColumns;
    this.rsltTypeActual = rsltTypeActual;
    this.ResultOrFileType = ResultOrFileType;
    this.requestID = requestID;

    //debugger;
    /////to add only preapred column  i.e show on main screen.
    let preparedcol = this.columnModelGenerator.prepareColumns(this.columns);
    preparedcol.forEach((col) => {
      this.respColumnsList.push(col.name);
    });

    this.columns.forEach(col => {      
      //this.respColumnsList.push(col.name);
      if (col.filterValues && typeof col.filterValues === 'string') {
        col.filterValues = this.service.getOptions.bind(this.service, col.filterValues);
      }
    });
 }

  get filters(): FilterMetadata { return this.dataFilter.filters; }
  set filters(val: FilterMetadata) {
    this.dataFilter.filters = val;
    this.events.onFilter();
  }

  //main function to be called from component pointing to service connecting to DB
  async loadItems() {
    if (this.requestID == "" || this.requestID == undefined)
      return await this.getItems(this.settings.virtualScroll);
    else
      return await this.getItemsByID(this.settings.virtualScroll);

    //return this.getItems(this.settings.virtualScroll);
  }

  clearAllFilters() {
    this.service.clearAllFilters();
  }

  async getItems(concatRows: boolean = false): Promise<any> {
    //console.log('dm-enter')
    if (concatRows === true && this.pagerCache[this.pager.current]) {
      return Promise.resolve();
    }
    let groupRowsBybool = false;
    if (this.settings.groupRowsBy) {
      if (this.settings.groupRowsBy.length > 0)
        groupRowsBybool = true;
    }
    this.events.onLoading(true);
    this.setSortMetaGroup();
    //console.log(this.sorter.sortMeta)
    //console.log(this.dataFilter.filters);

    //actual set of rows from database fetched and loading in table
    //console.log(this.pager.perPageOrCurrPageChanged)
    //console.log(this.pagerCache)
    const requestMeta: RequestMetadata = {
      pageMeta: { currentPage: this.pager.current, perPage: this.pager.perPage, perPageOrCurrPageChanged: this.pager.perPageOrCurrPageChanged },
      filters: this.dataFilter.filters,
      sortMeta: this.sorter.sortMeta,
      globalFilterValue: this.dataFilter.globalFilterValue,
      rsltType: this.rsltType,
      rsltTypeActual: this.rsltTypeActual,
      ResultOrFileType: this.ResultOrFileType,
      respColumnsList: this.respColumnsList,
      groupRowsBy: groupRowsBybool,
    };
    //sets the total number of records - demo service
    return await this.service
      .getItems(requestMeta)
      .then(data => {
        data.items.forEach(x => x.expanded = true);//For Call Timestamp grouping, makes all sub tables expanded or not, by default - IMP
        this.rows = (concatRows) ? this.rows.concat(data.items) : data.items;
        this.rowsRest = data.itemsRest;
        //console.log(this.rows)
        //console.log(this.rowsRest)
        if (concatRows) {
          this.pager.total = (data._meta.totalCount > this.rows.length) ? this.rows.length + 1 : this.rows.length;
        } else {
          this.pager.total = data._meta.totalCount;
        }
        this.pager.perPage = data._meta.perPage;
        this.pager.perPageOrCurrPageChanged = data._meta.perPageOrCurrPageChanged;
        this.pagerCache[this.pager.current] = true;
        //if (data._meta.clearSortOrder)
        //  this.sorter.sortMeta = [];
        //console.log(this.sorter.sortMeta)
        //console.log('dm-exit')
        //this.refreshed = true;
      })
      .finally(() => {
        this.events.onLoading(false);
        this.ResultOrFileType = 0;//IMP - resetting for records per page sel event
      });
  }

  async getItemsByID(concatRows: boolean = false): Promise<any> {
    //console.log(concatRows)
    if (concatRows === true && this.pagerCache[this.pager.current]) {
      return Promise.resolve();
    }
    this.events.onLoading(true);
    this.setSortMetaGroup();
    const requestMeta: RequestMetadata = {
      pageMeta: { currentPage: this.pager.current, perPage: this.pager.perPage, perPageOrCurrPageChanged: this.pager.perPageOrCurrPageChanged },
      filters: this.dataFilter.filters,
      sortMeta: this.sorter.sortMeta,
      globalFilterValue: this.dataFilter.globalFilterValue,
      rsltType: this.rsltType,
      id: parseInt(this.requestID)
    };
    //sets the total number of records
    return await this.service
      .getItemsByID(requestMeta)
      .then(data => {
        this.rows = (concatRows) ? this.rows.concat(data.items) : data.items;
        if (concatRows) {
          this.pager.total = (data._meta.totalCount > this.rows.length) ? this.rows.length + 1 : this.rows.length;
        } else {
          this.pager.total = data._meta.totalCount;
        }
        this.pager.perPage = data._meta.perPage;
        this.pager.perPageOrCurrPageChanged = data._meta.perPageOrCurrPageChanged;
        this.pagerCache[this.pager.current] = true;
      })
      .finally(() => { this.events.onLoading(false); });
  }

  create(row: Row) {
    this.events.onLoading(true);
    this.service
      .post(row, '')
      .then(res => {
        if (this.refreshRowOnSave) {
          this.loadItems();
        } else {
          this.addRow(res || row);
        }
      })
      .finally(() => { this.events.onLoading(false); });
  }

  update(row: Row) {
    this.events.onLoading(true);
    this.service.put(row, '')
      .then(res => {
        this.afterUpdate(row, res);
      })
      .finally(() => { this.events.onLoading(false); });
  }

  delete(row: Row) {
    this.events.onLoading(true);
    this.service
      .delete(row, '')
      .then(res => {
        this.deleteRow(row);
      })
      .finally(() => { this.events.onLoading(false); });
  }
  deleteInternally(row: Row) {
    console.log(this)
    this.deleteRow(row);
  }

  afterUpdate(row: Row, result: any) {
    if (this.refreshRowOnSave) {
      this.refreshRow(row);
    } else {
      this.mergeRow(row, result || row);
    }
  }

  refreshRow(row: Row) {
    this.events.onLoading(true);
    this.service.getItem(row)
      .then(data => {
        this.mergeRow(row, data);
      })
      .finally(() => { this.events.onLoading(false); });
  }

  clear() {
    this.rows = [];
    this.pager.total = 0;
  }

  rowIsValid(row: Row) {
    const hasError = this.columns.some(x => {
      const errors = x.validate(row[x.name]);
      return (errors && errors.length > 0);
    });
    return !hasError;
  }

}
